import { render } from "./EditSecuritySettings.vue?vue&type=template&id=205a9689"
import script from "./EditSecuritySettings.vue?vue&type=script&lang=js"
export * from "./EditSecuritySettings.vue?vue&type=script&lang=js"

import "./EditSecuritySettings.vue?vue&type=style&index=0&id=205a9689&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__